/* eslint-disable global-require */
const buildTarget = process.env.BUILD_TARGET || 'development';
const configs = {
  development: () => require('./config/development'),
  production: () => require('./config/production'),
  alpha: () => require('./config/alpha'),
  staging: () => require('./config/staging'),
};
const config = configs[buildTarget]();
export default config.default;
